module.exports = __webpack_public_path__ + "img/open-lock.46d9ae16.png";